import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './ContextMenu.css';

/**
 * ContextMenu 컴포넌트
 * @param {Object} props
 * @param {boolean} props.visible - 메뉴 표시 여부
 * @param {number} props.x - 메뉴 X 좌표
 * @param {number} props.y - 메뉴 Y 좌표
 * @param {Array<{label: string, onClick: function, disabled?: boolean}>} props.items - 메뉴 항목
 * @param {function} props.onClose - 메뉴 닫힘 콜백
 */
const ContextMenu = ({ visible, x, y, items, onClose }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    if (!visible) return;
    
    const handleClickOutside = (e) => {
      // 메뉴 내부 클릭은 무시
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };
    
    const handleEscKey = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    
    // click 이벤트로 변경 (mousedown보다 늦게 발생하여 메뉴 아이템 클릭이 먼저 처리됨)
    setTimeout(() => {
      document.addEventListener('click', handleClickOutside);
      document.addEventListener('keydown', handleEscKey);
    }, 0);
    
    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [visible, onClose]);

  if (!visible) return null;

  const menu = (
    <ul
      className="custom-context-menu"
      ref={menuRef}
      style={{
        position: 'fixed',
        top: y,
        left: x,
        zIndex: 999999,
        minWidth: 160,
        background: '#fff',
        border: '2px solid #333',
        borderRadius: 8,
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
        padding: '4px 0',
        margin: 0,
        listStyle: 'none',
        opacity: 1,
        visibility: 'visible',
        display: 'block',
        pointerEvents: 'auto'
      }}
    >
      {items.map((item, idx) =>
        item.label === '---' ? (
          <li
            key={idx}
            style={{
              height: 1,
              backgroundColor: '#e0e0e0',
              margin: '4px 8px',
              listStyle: 'none'
            }}
          />
        ) : (
          <li
            key={idx}
            className={`context-menu-item${item.disabled ? ' disabled' : ''}`}
            style={{
              padding: '10px 16px',
              cursor: item.disabled ? 'not-allowed' : 'pointer',
              color: item.disabled ? '#aaa' : '#333',
              fontSize: 14,
              userSelect: 'none',
              borderBottom: idx < items.length - 1 ? '1px solid #f0f0f0' : 'none',
              transition: 'background-color 0.15s ease'
            }}
            onMouseDown={(e) => {
              e.stopPropagation();
              e.preventDefault();
              if (!item.disabled) {
                item.onClick();
                onClose();
              }
            }}
          >
            {item.label}
          </li>
        )
      )}
    </ul>
  );

  return createPortal(menu, document.body);
};

export default ContextMenu;
